import { API, baseClient } from "../index";

/** @param {string} id - Quiz id. @param {object} [params] - Optional query params (e.g. { _t: Date.now() } para evitar caché). */
export const getQuizById = (id, params) =>
	baseClient().get(`${API}/quiz/${id}`, params ? { params } : undefined);

/** Quizzes del escenario. Si pasas params.game, devuelve los de ese juego; si no, los globales. Devuelve [{ _id, fullName }]. */
export const getQuizIdsByScenario = (scenarioId, params) =>
	baseClient().get(`${API}/quiz/by-scenario/${scenarioId}`, params ? { params } : undefined);
